import { User } from '@supabase/supabase-js';

export type UserRole = 'admin' | 'operations' | 'viewer';

export interface UserPermissions {
  production_cycles?: { view?: boolean; edit?: boolean };
  feed?: { view?: boolean; enter?: boolean; transfer?: boolean };
  sales?: { view?: boolean; enter?: boolean };
  settlements?: { view?: boolean; create?: boolean; finalize?: boolean };
  ledger?: { view?: boolean; export?: boolean };
  review_resolve?: { view?: boolean; resolve?: boolean };
  reports?: { view?: boolean };
  master_tables?: { view?: boolean; edit?: boolean };
  users?: { admin?: boolean };
}

export const DEFAULT_DENY_PERMISSIONS: UserPermissions = {
  production_cycles: { view: false, edit: false },
  feed: { view: false, enter: false, transfer: false },
  sales: { view: false, enter: false },
  settlements: { view: false, create: false, finalize: false },
  ledger: { view: false, export: false },
  review_resolve: { view: false, resolve: false },
  reports: { view: false },
  master_tables: { view: false, edit: false },
  users: { admin: false },
};

export const ADMIN_FULL_PERMISSIONS: UserPermissions = {
  production_cycles: { view: true, edit: true },
  feed: { view: true, enter: true, transfer: true },
  sales: { view: true, enter: true },
  settlements: { view: true, create: true, finalize: true },
  ledger: { view: true, export: true },
  review_resolve: { view: true, resolve: true },
  reports: { view: true },
  master_tables: { view: true, edit: true },
  users: { admin: true },
};

export const OPERATIONS_PERMISSIONS: UserPermissions = {
  production_cycles: { view: true, edit: true },
  feed: { view: true, enter: true, transfer: true },
  sales: { view: true, enter: true },
  settlements: { view: true, create: true, finalize: false },
  ledger: { view: true, export: true },
  review_resolve: { view: true, resolve: false },
  reports: { view: true },
  master_tables: { view: true, edit: false },
  users: { admin: false },
};

export const VIEWER_PERMISSIONS: UserPermissions = {
  production_cycles: { view: true, edit: false },
  feed: { view: true, enter: false, transfer: false },
  sales: { view: true, enter: false },
  settlements: { view: true, create: false, finalize: false },
  ledger: { view: true, export: false },
  review_resolve: { view: false, resolve: false },
  reports: { view: true },
  master_tables: { view: false, edit: false },
  users: { admin: false },
};

export interface UserProfile {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  is_active: boolean;
  phone_number?: string | null;
  avatar_url?: string | null;
  permissions?: UserPermissions | null;
  created_at: string;
  updated_at?: string;
}

export interface AuthState {
  user: User | null;
  profile: UserProfile | null;
  role: UserRole | null;
  isAdmin: boolean;
  isOperations: boolean;
  isViewer: boolean;
  loading: boolean;
  error: string | null;
}
